import React from 'react'

const Footer = () => {
  return (
    <div className="footer">
      <h4>Food Villa</h4>
      <p>Built with React • Custom API Integration • Responsive Design</p>
      <p>Connect: [Ravi2001pandey@gmail.com] • © {new Date().getFullYear()}</p>
    </div>

  )
}

export default Footer